export const movieLists = [
    { id: '1', path: '/movies/popular', text: 'Popular' },
    { id: '2', path: '/movies/trending', text: 'Trending' },
    { id: '3', path: '/movies/top_rated', text: 'Top Rated' },
    { id: '4', path: '/movies/now_playing', text: 'Now Playing' },
    { id: '5', path: '/movies/upcoming', text: 'Upcoming' },
];

export const seriesLists = [
    { id: '1', path: '/tv/popular', text: 'Popular' },
    { id: '2', path: '/tv/trending', text: 'Trending' },
    { id: '3', path: '/tv/top_rated', text: 'Top Rated' },
    { id: '4', path: '/tv/on_the_air', text: 'On the air' },
    { id: '5', path: '/tv/airing_today', text: 'Airing Today' },
]